import { render, staticRenderFns } from "./WhatsAppBadgeIcon.vue?vue&type=template&id=b8f9a28c&scoped=true"
import script from "./WhatsAppBadgeIcon.vue?vue&type=script&lang=js"
export * from "./WhatsAppBadgeIcon.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppBadgeIcon.vue?vue&type=style&index=0&id=b8f9a28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f9a28c",
  null
  
)

export default component.exports